export interface Review {
  name: string;
  role: string;
  content: string;
  rating: number;
}

export const reviews: Review[] = [
  {
    name: "南风知我意",
    role: "异世界穿越爱好者",
    content:
      "分类做得太清楚了！异世界、精灵、妖怪分区一列，想看的题材一眼就能找到。简介写得很对味，连追好几部都没踩雷。",
    rating: 5,
  },
  {
    name: "鹿屿晚风",
    role: "精灵契约题材粉丝",
    content:
      "最喜欢月光契约这类情感细腻的精灵题材，网站把同风格的作品聚在一起，省了我到处翻的功夫，体验很舒服。",
    rating: 5,
  },
  {
    name: "山海拾荒人",
    role: "妖怪神话深度读者",
    content:
      "神话分类的选品很有品位，九尾狐、山鬼、龙宫都有收录，还配了题材解析文章，边读漫画边涨姿势，点赞。",
    rating: 4,
  },
  {
    name: "拾光留白",
    role: "漫画老书虫",
    content:
      "页面干净清爽，更新速览每周都有，追更党福音。剧情简介写得不剧透又吊胃口，很会拿捏读者心理。",
    rating: 5,
  },
];